module.exports = __webpack_public_path__ + "img/gk_img4.81263c66.png";